import type { Investigation } from '@onefootprint/request-types/dashboard';
import getTruncatedName from '@/utils/get-truncated-name';

const getEntityName = (investigation: Investigation): string => {
  if (investigation.entityKind === 'business') {
    return investigation.data.find(item => item.identifier === 'business.name')?.value || '-';
  }

  return getTruncatedName(investigation.data);
};

export default getEntityName;
